import React, { useContext, useState } from "react";
import 'react-phone-number-input/style.css';
import PhoneInputBase, { formatPhoneNumber, isValidPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import styles from './PhoneInput.module.scss';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { combineClasses } from '../../utils';
import { AccelContext, Context } from '../AccelProvider/AccelProvider';
import { LoadingOverlay } from '..';
import { useAsyncEffect } from '../hooks/useAsyncEffect';

export { formatPhoneNumber, isValidPhoneNumber, formatPhoneNumberIntl };

type CustomPhoneInputProps = {
    size?: SizeType;
    borderless?: boolean;
    disabled?: boolean;
    placeholder?: string;
    value?: string;
    onChange?: (phone: string) => void;
    onBlur?: () => void;
    className?: string;
    autoFetchCountry?: boolean;
    defaultCountry?: string | null;
}
/**
 * @deprecated Use PhoneInput2 instead
 */
const PhoneInput: React.FC<CustomPhoneInputProps> = ({ borderless, autoFetchCountry, defaultCountry, disabled, onChange, onBlur, placeholder, size, value, className }) => {
    let ctx = useContext(Context);

    const locator = ctx.geoLocator;
    const [country, setCountry] = useState<string | undefined>(defaultCountry?.toUpperCase());

    useAsyncEffect(async (isActive) => {
        if (defaultCountry) {
            setCountry(defaultCountry.toUpperCase());
            return;
        }
        const countryString = await locator.fetchCounty();
        if (isActive())
            setCountry(countryString.toUpperCase());
    }, [defaultCountry]);

    if (autoFetchCountry && !country)
        return <LoadingOverlay size='small' />;
    return <div className={combineClasses(styles.phone_input, className)} data-size={size ?? 'middle'} data-borderless={borderless ?? false}>
        <PhoneInputBase value={value ?? ''} onChange={(x) => onChange?.(x as string)} onBlur={() => onBlur?.()} disabled={disabled} placeholder={placeholder} defaultCountry={country} />
    </div>;
}
PhoneInput.defaultProps = {
    autoFetchCountry: true
}
export default PhoneInput;